var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "click",
      "autoHide": true
    },
    on: {
      "auto-hide": _vm.close
    }
  }, [_c('span', {
    staticClass: "tooltip-target",
    attrs: {
      "data-testid": "client-banner-insurance"
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.client.health_insurance) ? _c('span', {
    staticClass: "badge badge-secondary badge_health_insurance",
    class: '_' + _vm.client.health_insurance.code,
    attrs: {
      "title": _vm.client.health_insurance.name
    }
  }, [_vm._v(_vm._s(_vm.client.health_insurance.code === '---' ? _vm.client.health_insurance.shortcut : _vm.client.health_insurance.code) + "\n            "), (_vm.client.health_insurance.type === '2') ? _c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.client.health_insurance.type === '3') ? _c('i', {
    staticClass: "fa fa-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.client.health_insurance.type === '4') ? _c('i', {
    staticClass: "fa fa-globe",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]) : _c('span', {
    staticClass: "tooltip-target badge pointer badge-warning badge_health_insurance",
    attrs: {
      "role": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" chybí zdrav. pojišťovna")])]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [(!_vm.insuranceCompaniesPending) ? _c('div', {
    staticClass: "container tooltip_container tooltip_1_5_col"
  }, [_c('div', {
    staticClass: "row tooltip_header"
  }, [_c('div', {
    staticClass: "col-sm-2 text-left"
  }, [(_vm.editMode === false && _vm.client.health_insurance) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "data-testid": "client-insurance-edit"
    },
    on: {
      "click": _vm.edit
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" změnit")]) : (_vm.editMode === true) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "data-testid": "client-insurance-back"
    },
    on: {
      "click": _vm.view
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" zpět")]) : _vm._e()]), _vm._v(" "), (_vm.editMode === true) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Úprava zdravotního pojištění")]) : (!_vm.client.health_insurance) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Výběr zdravotního pojištění")]) : _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Detail zdravotního pojištění")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  })]), _vm._v(" "), (_vm.editMode === true) ? _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("pojišťovna")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("druh")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3 text-right"
  }, [_vm._v("platné od")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3 text-right"
  }, [_vm._v("platné do")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-1"
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.clientInsurances), function(ci) {
    return _c('tr', {
      staticClass: "row m-0 text-left",
      class: ci.is_valid ? 'font-weight-bold' : '',
      attrs: {
        "data-testid": "client-insurance-row"
      }
    }, [_c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v(_vm._s(ci.insurance_company.shortcut))]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3"
    }, [_vm._v(_vm._s(ci.type) + " - " + _vm._s(_vm._f("insuranceTypeIntToName")(ci.type)))]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3 text-right"
    }, [_vm._v(_vm._s(ci.valid_from))]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-3 text-right"
    }, [_vm._v(_vm._s(ci.valid_to))]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1 text-right"
    }, [(ci.valid_to === null) ? [(!_vm.deleteInsurancePending) ? _c('button', {
      staticClass: "btn btn-sm btn-outline-danger",
      attrs: {
        "data-testid": "client-insurance-delete"
      },
      on: {
        "click": function($event) {
          _vm.deleteInsurance(ci.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-outline-danger disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _vm._e()], 2)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.postInsurance(_vm.client.id)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "insuranceCompanySelect"
    }
  }, [_vm._v("Zdravotní pojišťovna")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insurance.insurance_company),
      expression: "insurance.insurance_company"
    }],
    staticClass: "form-control",
    attrs: {
      "data-testid": "client-insurance-company",
      "id": "insuranceCompanySelect"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.insurance.insurance_company = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.insuranceCompanies), function(ic) {
    return _c('option', {
      domProps: {
        "value": ic.code
      }
    }, [_vm._v(_vm._s(ic.code) + " - " + _vm._s(ic.shortcut) + " - " + _vm._s(ic.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "ml-sm-2 mr-sm-2",
    attrs: {
      "for": "insuranceValidFrom"
    }
  }, [_vm._v("od data")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insurance.valid_from),
      expression: "insurance.valid_from"
    }],
    staticClass: "form-control",
    attrs: {
      "data-testid": "client-insurance-valid-from",
      "id": "insuranceValidFrom"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.insurance.valid_from = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.possibleDates), function(pd) {
    return _c('option', {
      domProps: {
        "value": pd
      }
    }, [_vm._v(_vm._s(pd))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "ml-sm-2 mr-sm-2",
    attrs: {
      "for": "insuranceType"
    }
  }, [_vm._v("druh")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insurance.type),
      expression: "insurance.type"
    }],
    staticClass: "form-control",
    attrs: {
      "data-testid": "client-insurance-type",
      "id": "insuranceType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.insurance.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((4), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n) + " - " + _vm._s(_vm._f("insuranceTypeIntToName")(n)))])
  }))]), _vm._v(" "), (!_vm.insurancePending) ? _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "data-testid": "client-insurance-save",
      "type": "submit"
    }
  }, [_vm._v("Uložit")]) : _c('button', {
    staticClass: "btn btn-primary btn-sm disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])]) : (!_vm.client.health_insurance) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.postInsurance(_vm.client.id)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "insuranceCompanySelect"
    }
  }, [_vm._v("Zdravotní pojišťovna")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insurance.insurance_company),
      expression: "insurance.insurance_company"
    }],
    staticClass: "form-control",
    attrs: {
      "data-testid": "client-insurance-company",
      "id": "insuranceCompanySelect"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.insurance.insurance_company = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.insuranceCompanies), function(ic) {
    return _c('option', {
      domProps: {
        "value": ic.code
      }
    }, [_vm._v(_vm._s(ic.code) + " - " + _vm._s(ic.shortcut) + " - " + _vm._s(ic.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "ml-sm-2 mr-sm-2",
    attrs: {
      "for": "insuranceType"
    }
  }, [_vm._v("druh")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insurance.type),
      expression: "insurance.type"
    }],
    staticClass: "form-control",
    attrs: {
      "data-testid": "client-insurance-type",
      "id": "insuranceType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.insurance.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((4), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n) + " - " + _vm._s(_vm._f("insuranceTypeIntToName")(n)))])
  }))]), _vm._v(" "), (!_vm.insurancePending) ? _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "data-testid": "client-insurance-save",
      "type": "submit"
    }
  }, [_vm._v("Uložit")]) : _c('button', {
    staticClass: "btn btn-primary btn-sm disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])]) : _c('div', {}, [_c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('div', {}, [_c('span', {
    staticClass: "badge badge-secondary badge_health_insurance badge_large",
    class: '_' + _vm.client.health_insurance.code,
    attrs: {
      "title": _vm.client.health_insurance.name
    }
  }, [_vm._v(_vm._s(_vm.client.health_insurance.shortcut))])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-center",
    attrs: {
      "data-testid": "client-insurance-detail"
    }
  }, [_c('div', {
    staticClass: "p-2"
  }, [_c('span', {
    staticClass: "h5"
  }, [_vm._v(_vm._s(_vm.client.health_insurance.name))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "h6"
  }, [_vm._v("(" + _vm._s(_vm._f("insuranceTypeIntToName")(_vm.client.health_insurance.type)) + ")")])])])])]) : _vm._e()])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f12f7026","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client/components/ClientInsurance.vue
// module id = 316
// module chunks = 0